import React from "react";
import { Card } from "primereact/card";
import AdminOnly from "../AdminOnly";

const NoShareHolders = ({
  onAddShareholderClick,
  directorTab,
  onDirectorClick,
}) => {
  return (
    <>
      {directorTab ? (
        <>
          <div className="formgrid grid mt-4">
            <div className="field col-6 mb-4 pl-0">
              <div className="input-wrapper ml-2">
                <span className="pi pi-search span-left"></span>
                <input
                  type="text"
                  placeholder="Search directors by given name, surname or position"
                  className="input-field appearance-none outline-none w-full"
                />
                <span className="pi pi-search span-right"></span>
              </div>
            </div>
            <div className="field col-6 mb-0">
              <div className="flex justify-content-end">
                <AdminOnly>
                  <button className="add-new-contact" onClick={onDirectorClick}>
                    Add Board Member <span className="pi pi-plus ml-2"></span>
                  </button>
                </AdminOnly>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex items-start gap-3 mt-4">
          <div className="field mb-4 p-0 flex-grow-1">
            <div className="input-wrapper">
              <span className="pi pi-search span-left"></span>
              <input
                type="text"
                placeholder="Search shareholders by given name, surname or shareholder type"
                className="input-field appearance-none outline-none w-full shareholder-search-input"
              />
              <span className="pi pi-search span-right"></span>
            </div>
          </div>
          <div className="field mb-0 flex-shrink-0">
            <div className="flex justify-content-end add-shareholder-button-div">
              <AdminOnly>
                <button
                  className="add-new-contact"
                  onClick={onAddShareholderClick}
                >
                  Add Shareholder <span className="pi pi-plus ml-2"></span>
                </button>
              </AdminOnly>
            </div>
          </div>
        </div>
      )}
      <Card>
        <div className="formgrid grid flex justify-content-center align-item-center">
          <div className="no-key-container">
            <div>
              <svg
                width="136"
                height="137"
                viewBox="0 0 136 137"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_5888_237283)">
                  <rect
                    x="12"
                    y="10.5"
                    width="112"
                    height="112"
                    rx="40"
                    fill="white"
                    shapeRendering="crispEdges"
                  />
                  <path
                    d="M52 34.5H88H92C94.125 34.5 96 36.375 96 38.5V78.5C96 80.75 94.125 82.5 92 82.5V90.5C94.125 90.5 96 92.375 96 94.5C96 96.75 94.125 98.5 92 98.5H88H52C45.375 98.5 40 93.125 40 86.5V46.5C40 39.875 45.375 34.5 52 34.5ZM52 82.5C49.75 82.5 48 84.375 48 86.5C48 88.75 49.75 90.5 52 90.5H84V82.5H52ZM56 52.5C56 53.625 56.875 54.5 58 54.5H82C83 54.5 84 53.625 84 52.5C84 51.5 83 50.5 82 50.5H58C56.875 50.5 56 51.5 56 52.5ZM58 58.5C56.875 58.5 56 59.5 56 60.5C56 61.625 56.875 62.5 58 62.5H82C83 62.5 84 61.625 84 60.5C84 59.5 83 58.5 82 58.5H58Z"
                    fill="#188A42"
                  />
                  <path
                    opacity="0.4"
                    d="M52 34.5H88H92C94.125 34.5 96 36.375 96 38.5V78.5C96 80.75 94.125 82.5 92 82.5V90.5C94.125 90.5 96 92.375 96 94.5C96 96.75 94.125 98.5 92 98.5H88H52C45.375 98.5 40 93.125 40 86.5V46.5C40 39.875 45.375 34.5 52 34.5ZM52 82.5C49.75 82.5 48 84.375 48 86.5C48 88.75 49.75 90.5 52 90.5H84V82.5H52ZM56 52.5C56 53.625 56.875 54.5 58 54.5H82C83 54.5 84 53.625 84 52.5C84 51.5 83 50.5 82 50.5H58C56.875 50.5 56 51.5 56 52.5ZM58 58.5C56.875 58.5 56 59.5 56 60.5C56 61.625 56.875 62.5 58 62.5H82C83 62.5 84 61.625 84 60.5C84 59.5 83 58.5 82 58.5H58Z"
                    fill="#188A42"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_5888_237283"
                    x="0"
                    y="0.5"
                    width="136"
                    height="136"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_5888_237283"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_5888_237283"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <p className="no-key-personnel mb-2">
              {directorTab
                ? "No Directors registered yet"
                : " No shareholders registered yet"}
            </p>
            <AdminOnly>
              <p className="no-key-personnel-para">Lets add your first one</p>
              {directorTab ? (
                <button className="cancel-btns" onClick={onDirectorClick}>
                  {" "}
                  Add Board Member<span className="pi pi-plus mb-1 ml-2"></span>
                </button>
              ) : (
                <button className="cancel-btns" onClick={onAddShareholderClick}>
                  {" "}
                  Add Shareholder<span className="pi pi-plus mb-1 ml-2"></span>
                </button>
              )}
            </AdminOnly>
          </div>
        </div>
      </Card>
    </>
  );
};

export default NoShareHolders;
